<template>
  <section>
    <h1 class="subtitle">
      Account Breakdown
    </h1>
    <div class="account-breakdown">
      <div class="dashboard-row">
        <div class="dashboard-col">
          <AccountBreakdown />
        </div>

        <div class="dashboard-col">
          <TaxonomyBreakdown />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AccountBreakdown from '@/components/dashboard/usage/breakdown/AccountBreakdown'
import TaxonomyBreakdown from '@/components/dashboard/usage/taxonomy-breakdown/AccountTaxonomyBreakdown'
import { mapActions } from 'vuex'

export default {
    components: {
        AccountBreakdown,
        TaxonomyBreakdown,
    },
    mounted() {
        this.retrieveCcloneList()
        this.retrieveExpiringAudiences()
    },
    methods: {
        ...mapActions('dashboardAccount', [
            'retrieveCcloneList',
            'retrieveExpiringAudiences',
        ]),
    },
}
</script>
<style lang="scss">
.account-breakdown {
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 100%;
  max-height: 120vh;

  .dashboard-row {
    display: flex;
    width: 100%;
    height: 100%;
    max-height: 120vh;
    gap: 20px;
  }

  .dashboard-col {
    flex: 1;
    min-width: 0;
  }
  @media screen and (max-width: 900px) {
    .dashboard-row {
      flex-direction: column;
    }
  }
}
</style>

